/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import NodeTouchActionComponent from '../Utility/Component/Action/NodeTouchActionComponent';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import IPopupManager from '../Utility/Component/Popup/IPopupManager';
import { AutoPlayManager } from './AutoPlayManager';
import { ContextKey } from '../Utility/Component/Configurator/ContextKey';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Sets AutoPlay count on touch.
 */
@cc._decorator.ccclass
export default class AutoPlaySetterComponent extends NodeTouchActionComponent
{
    /** Count to set on the autoplay manager. */
    @property({ type: cc.Integer, visible: true })
    private _autoPlayAmount: number = 1;
    public get AutoPlayAmount(): number { return this._autoPlayAmount; }
    public set AutoPlayAmount(value: number) { this._autoPlayAmount = value; }

    @property()
    protected disablePopupManager: boolean = false;
    public set DisablePopupManager(value: boolean) { this.disablePopupManager = value; }

    /** @hidden */
    private _autoPlayManagerRef: InjectableComponent<AutoPlayManager> = new InjectableComponent<AutoPlayManager>();
    /** @hidden */
    private _popupManagerRef: InjectableComponent<IPopupManager> = new InjectableComponent<IPopupManager>();

    /** @hidden */
    protected setContexts(): void
    {
        this._autoPlayManagerRef.SetContext(AutoPlayManager);
        this._popupManagerRef.SetContext(ContextKey.POPUP_MANAGER);
    }

    /** @hidden */
    protected action = (): void =>
    {
        if (this._autoPlayAmount > 0)
        {
            this._autoPlayManagerRef.Value.AutoPlays = this._autoPlayAmount;
        }
        else
        {
            this._autoPlayManagerRef.Value.ClearAutoPlay();
        }

        if (this.disablePopupManager) { this._popupManagerRef.Value.Disable(); }
    }
}
